import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { getRegisterLink } from '../utils/getLinks';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout/Layout';
import Error from '../Components/Login/error';
import LoginForm from '../Components/Login/login-form';
import PageTitle from '../Components/PageTitle.js';

const LoginPage = ({ user, config, cmsSourceFirebase, loading, actions }) => {
    const page = {
        title: 'Login',
        className: 'login',
    };

    return user?.loggedIn ? (
        <Redirect to={`/enter`} />
    ) : (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title={page?.title} />
            </div>

            <LoginInner user={user} actions={actions} config={config} loading={loading} />
        </Layout>
    );
};

export const LoginInner = ({ user, actions, loading, config }) => {
    return (
        <div className='login-container w-100'>
            <div className='row justify-content-center'>
                <div className='col col-lg-10'>
                    <Error user={user} actions={actions} />
                </div>
            </div>
            <div className='row justify-content-center'>
                <div className='col col-lg-8'>
                    <LoginForm user={user} actions={actions} config={config} loading={loading} />
                </div>
            </div>
            <div className='row justify-content-center my-4'>
                <div className='register-now col-xs-12 text-center'>
                    <a className='text-center register-now' href={getRegisterLink(config)} target='_blank' rel='noopener noreferrer'>
                        Not Registered Yet?
                        <br />
                        Register
                    </a>
                </div>
            </div>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
